import baseScmService from 'services/baseScmService';

const courseGroupsService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getCourseGroups: build.query({
      query: () => ({
        method: 'GET',
        url: '/course-groups/',
      }),
      keepUnusedDataFor: 60 * 60, // In seconds (Caching for an hour)
    }),
  }),
  overrideExisting: false,
});

export const { useGetCourseGroupsQuery } = courseGroupsService;

export default courseGroupsService;
